/**
 * Whitelist of creator handles eligible for market creation.
 * Only creators in this set (from the top 100 in Kaito) will get markets deployed.
 * All handles are lowercase for case-insensitive matching.
 */
export const WHITELISTED_HANDLES: ReadonlySet<string> = new Set([
	"vitalikbuterin",
	"blknoiz06",
	"mert",
	"binji_x",
	"zachxbt",
	"chameleon_jeff",
	"laurashin",
	"icobeast",
	"karpathy",
	"mdudas",
	"saylor",
	"balajis",
	"pythianism",
	"hosseeb",
	"darioamodei",
	"notthreadguy",
	"brian_armstrong",
	"nic_carter",
	"jessepollak",
	"fundstrat",
	"vibhu",
	"toly",
	"cz_binance",
	"qwqiao",
	"thinkingusd",
	"ntmoney",
	"mattprd",
	"hasufl",
	"davidecrapis",
	"intern",
	"peterschiff",
	"jerallaire",
	"dcinvestor",
	"0xdeployer",
	"vladtenev",
])

/**
 * Configuration for the custom binary question market that replaces
 * Fall from Grace in the featured slot.
 */
export const CUSTOM_QUESTION_CONFIG = {
	question: "Will Moltbook reach 10,000,000 AI agents by February 9, 2026?",
	displayName: "Moltbook",
	handlePrefix: "custom-question",
	outcomeLabels: ["Yes", "No"],
	avatarUrl: "/moltbook.png",
	customDescription:
		'Resolution criteria: This market resolves YES if Moltbook publicly displays 10,000,000 or more total AI agents on its platform at any point on or before February 9, 2026 (23:59 UTC). Otherwise, it resolves NO.\n\nSource of truth: Moltbook.com (agent counter) will be used as the sole resolution source. If the counter is removed or replaced, an official Moltbook announcement or API-exposed metric may be used instead. As Feb 2, 2026, Moltbook reports approximately 1.57M AI agents, positioning it as a fast-growing "agent-native Reddit".',
} as const
